/**
 * Custom Pricing Engine & Global Currency Manager for aya Shopify Theme
 */

/**
 * aya Global Currency & Exchange Rate Manager
 */
window.ayaCurrency = {
  rates: {
    USD: { symbol: "$", flag: "🇺🇸", rate: 1.0, name: "USD ($)" },
    INR: { symbol: "₹", flag: "🇮🇳", rate: 87.0, name: "INR (₹)" },
    GBP: { symbol: "£", flag: "🇬🇧", rate: 0.79, name: "GBP (£)" },
    CAD: { symbol: "CA$", flag: "🇨🇦", rate: 1.38, name: "CAD ($)" },
    EUR: { symbol: "€", flag: "🇪🇺", rate: 0.92, name: "EUR (€)" },
    AUD: { symbol: "AU$", flag: "🇦🇺", rate: 1.52, name: "AUD ($)" }
  },

  getActiveCurrency: function() {
    try {
      const saved = localStorage.getItem("aya_active_currency");
      if (saved && this.rates[saved]) return saved;
    } catch (e) {
      console.warn("[ayaCurrency] LocalStorage error:", e);
    }
    return "USD";
  },

  getRateInfo: function(currCode) {
    const code = currCode || this.getActiveCurrency();
    return this.rates[code] || this.rates.USD;
  },

  setActiveCurrency: function(code) {
    if (!this.rates[code]) return;
    try {
      localStorage.setItem("aya_active_currency", code);
    } catch (e) {
      console.warn("[ayaCurrency] LocalStorage write error:", e);
    }
    this.syncUI();
    this.updateAllPrices();
  },

  format: function(amountInUSD) {
    if (isNaN(amountInUSD) || amountInUSD === null) return "";
    const activeCurr = this.getActiveCurrency();
    const info = this.getRateInfo(activeCurr);
    const converted = amountInUSD * info.rate;
    
    // Format based on locale / currency
    let formattedNum;
    if (activeCurr === "INR") {
      formattedNum = Math.round(converted).toLocaleString('en-IN');
    } else {
      formattedNum = Math.round(converted).toLocaleString('en-US');
    }
    return info.symbol + formattedNum;
  },

  formatCents: function(centsInUSD) {
    const dollars = parseFloat(centsInUSD) / 100.0;
    return this.format(dollars);
  },

  syncUI: function() {
    const active = this.getActiveCurrency();
    const info = this.getRateInfo(active);

    // Sync Desktop selector and flag
    const desktopSelect = document.getElementById("DesktopCurrencySelect");
    const desktopFlag = document.getElementById("DesktopActiveFlag");
    if (desktopSelect) desktopSelect.value = active;
    if (desktopFlag) desktopFlag.textContent = info.flag;

    // Sync Mobile selector and flag
    const mobSelect = document.getElementById("MobCurrencySelect");
    const mobFlag = document.getElementById("MobActiveFlag");
    if (mobSelect) mobSelect.value = active;
    if (mobFlag) mobFlag.textContent = info.flag;
  },

  updateAllPrices: function() {
    // 1. Recalculate main product if on product page
    if (typeof window.recalculateCustomPrice === "function") {
      window.recalculateCustomPrice();
    }
    if (typeof window.recalculateStandardPrice === "function") {
      window.recalculateStandardPrice();
    }

    // 2. Update all collection product cards on the page
    const cards = document.querySelectorAll(".product-card-lux");
    cards.forEach(card => {
      // Update swatch dots
      const dots = card.querySelectorAll(".card-swatch-dot-lux");
      dots.forEach(dot => {
        const rawPrice = dot.getAttribute("data-price-raw");
        const rawComp = dot.getAttribute("data-comp-price-raw");
        if (rawPrice) {
          const formatted = this.formatCents(rawPrice);
          dot.setAttribute("data-price", formatted);
        }
        if (rawComp) {
          const formattedComp = this.formatCents(rawComp);
          dot.setAttribute("data-comp-price", formattedComp);
        }
      });

      // Update active swatch or displayed card prices
      const priceEl = card.querySelector(".card-price-lux");
      const compPriceEl = card.querySelector(".card-comp-price-lux");
      const wishBtn = card.querySelector(".card-wishlist-btn-lux");

      const activeDot = card.querySelector(".card-swatch-dot-lux.active");
      if (activeDot) {
        const p = activeDot.getAttribute("data-price");
        const cp = activeDot.getAttribute("data-comp-price");
        if (priceEl && p) priceEl.textContent = p;
        if (compPriceEl && cp) compPriceEl.textContent = cp;
        if (wishBtn && p) wishBtn.setAttribute("data-price", p);
      } else {
        if (priceEl) {
          const rawP = priceEl.getAttribute("data-price-raw");
          if (rawP) {
            const formatted = this.formatCents(rawP);
            priceEl.textContent = formatted;
            if (wishBtn) wishBtn.setAttribute("data-price", formatted);
          }
        }
        if (compPriceEl) {
          const rawCP = compPriceEl.getAttribute("data-comp-price-raw");
          if (rawCP) compPriceEl.textContent = this.formatCents(rawCP);
        }
      }
    });

    // 3. Dispatch custom event for other widgets (e.g., cart, wishlist)
    window.dispatchEvent(new CustomEvent("aya:currency_changed", { 
      detail: { currency: this.getActiveCurrency(), info: this.getRateInfo() } 
    }));
  },

  init: function() {
    this.syncUI();

    // Bind change listeners on desktop & mobile selects
    const desktopSelect = document.getElementById("DesktopCurrencySelect");
    if (desktopSelect) {
      desktopSelect.addEventListener("change", (e) => {
        this.setActiveCurrency(e.target.value);
      });
    }

    const mobSelect = document.getElementById("MobCurrencySelect");
    if (mobSelect) {
      mobSelect.addEventListener("change", (e) => {
        this.setActiveCurrency(e.target.value);
      });
    }

    // Document level delegation for any currency selects
    document.addEventListener("change", (e) => {
      if (e.target && (e.target.id === "DesktopCurrencySelect" || e.target.id === "MobCurrencySelect" || e.target.classList.contains("curr-select-lux") || e.target.classList.contains("mob-curr-select"))) {
        if (e.target.value !== this.getActiveCurrency()) {
          this.setActiveCurrency(e.target.value);
        }
      }
    });

    // Initial price sweep across cards on page
    this.updateAllPrices();
  }
};

function initPromoModalListeners(globalRates) {
  const promoGiftMinSpend = parseFloat(globalRates.promo_gift_min_spend) || 1000;
  const savingsBoxToggle = document.getElementById("SavingsInfoBoxToggle");
  const anniversaryCheckbox = document.getElementById("AnniversaryCheckbox");
  if (savingsBoxToggle && anniversaryCheckbox) {
    savingsBoxToggle.addEventListener("click", function() {
      anniversaryCheckbox.checked = true;
      anniversaryCheckbox.dispatchEvent(new Event('change'));
    });
  }

  const giftModal = document.getElementById("GiftDetailModal");
  const modalCloseBtn = document.getElementById("CloseGiftModalBtn");
  const giftTriggers = document.querySelectorAll(".gift-trigger-row, .info-modal-trigger");

  if (giftModal) {
    giftTriggers.forEach(trigger => {
      trigger.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        const modalBtnText = document.getElementById("ModalStickyBtnText");
        const remaining = Math.max(0, promoGiftMinSpend - (window.lastCalculatedPrice || 0));
        if (modalBtnText) {
          if (remaining > 0) {
            modalBtnText.textContent = `Spend ${window.ayaCurrency.format(remaining)} more to unlock`;
          } else {
            modalBtnText.textContent = `✓ Free Gift Unlocked (Added to Bag)`;
          }
        }

        const modalScrollBody = giftModal.querySelector(".modal-scrollable-body");
        if (modalScrollBody) {
          modalScrollBody.scrollTop = 0;
        }

        giftModal.style.display = "flex";
        document.body.style.overflow = "hidden"; // Prevent background scroll
      });
    });

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener("click", function() {
        giftModal.style.display = "none";
        document.body.style.overflow = ""; // Restore scroll
      });
    }

    giftModal.addEventListener("click", function(e) {
      if (e.target === giftModal) {
        giftModal.style.display = "none";
        document.body.style.overflow = "";
      }
    });
  }

  // Global thumbnail update helper
  window.updateModalBigImage = function(src, el) {
    const bigImg = document.getElementById("ModalBigImage");
    if (bigImg) bigImg.src = src;

    const thumbs = document.querySelectorAll(".modal-thumb");
    thumbs.forEach(t => t.style.borderColor = "transparent");
    if (el) el.style.borderColor = "var(--color-primary, #7c8c7b)";
  };
}

function initStandardProductHandler(productForm, globalRates, productMeta, priceDisplay, compPriceDisplay, everydaySavingsEl, totalSavingsEl, checkoutBtn) {
  console.log("[aya] Initializing standard product pricing (no custom metafields)");

  const variantsEl = document.getElementById("shopify-product-variants-json");
  let variants = [];
  if (variantsEl) {
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      console.error("[aya] Failed to parse product variants JSON:", e);
    }
  }

  const anniversaryCheckbox = document.getElementById("AnniversaryCheckbox");
  let compInflationPct = parseFloat(globalRates.comp_price_inflation_percentage);
  if (isNaN(compInflationPct) || compInflationPct < 0 || compInflationPct >= 100) {
    compInflationPct = 15;
  }
  // Reverse discount calculation:
  // Sale Price = Compare Price × (1 - Discount%)
  // Therefore Compare Price = Sale Price ÷ (1 - Discount%)
  const promoCompareMultiplier = 1 / (1 - (compInflationPct / 100));
  const promoGiftMinSpend = parseFloat(globalRates.promo_gift_min_spend) || 1000;
  const promoGiftValue = parseFloat(globalRates.promo_gift_value) || 245;
  const isPromoShown = globalRates.promo_show !== false && globalRates.promo_show !== 'false';

  function getSelectedVariant() {
    if (!variants || variants.length === 0) return null;
    if (variants.length === 1) return variants[0];

    const selectedRadios = document.querySelectorAll('.standard-variant-radio:checked');
    if (selectedRadios.length === 0) {
      const hiddenId = document.getElementById("ProductSelectedVariantId")?.value;
      return variants.find(v => String(v.id) === String(hiddenId)) || variants[0];
    }

    const selectedOptions = Array.from(selectedRadios).map(r => r.value);
    const matched = variants.find(v => {
      return v.options.every((opt, idx) => opt === selectedOptions[idx]);
    });
    return matched || variants[0];
  }

  function updateStandardPrice() {
    const selectedVariant = getSelectedVariant();
    let variantPrice = 0;
    let variantCompPrice = 0;

    if (selectedVariant) {
      variantPrice = selectedVariant.price / 100.0;
      variantCompPrice = (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) 
        ? (selectedVariant.compare_at_price / 100.0) 
        : 0;

      const variantIdInput = document.getElementById("ProductSelectedVariantId");
      if (variantIdInput) variantIdInput.value = selectedVariant.id;

      if (checkoutBtn) {
        if (selectedVariant.available) {
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = "Add to bag";
        } else {
          checkoutBtn.disabled = true;
          checkoutBtn.textContent = "Sold out";
        }
      }
    } else {
      variantPrice = parseFloat(productMeta.default_price || 0) / 100.0;
      variantCompPrice = parseFloat(productMeta.default_compare_at_price || 0) / 100.0;
    }

    const isPromoChecked = isPromoShown && (anniversaryCheckbox ? anniversaryCheckbox.checked : true);
    let displayPrice = variantPrice;
    let everydaySavingsVal = 0;
    let totalSavingsVal = 0;
    let isGiftEligible = false;

    const compPriceVal = variantCompPrice > 0 ? variantCompPrice : Math.round(variantPrice * promoCompareMultiplier);
    everydaySavingsVal = Math.max(0, compPriceVal - variantPrice);
    isGiftEligible = variantPrice >= promoGiftMinSpend;

    const promoActiveCard = document.getElementById("PromoActiveCard");
    const promoInactiveCard = document.getElementById("PromoInactiveCard");

    if (isPromoChecked) {
      displayPrice = variantPrice;
      if (promoActiveCard && promoInactiveCard) {
        promoActiveCard.style.display = "block";
        promoInactiveCard.style.display = "none";
      }
      if (compPriceDisplay) {
        if (compPriceVal > variantPrice) {
          compPriceDisplay.textContent = window.ayaCurrency.format(compPriceVal);
          compPriceDisplay.style.display = "inline";
        } else {
          compPriceDisplay.style.display = "none";
        }
      }
      if (everydaySavingsEl) {
        everydaySavingsEl.textContent = "-" + window.ayaCurrency.format(everydaySavingsVal);
      }
      if (totalSavingsEl) {
        const promoGiftValueCalculated = isGiftEligible ? promoGiftValue : 0;
        totalSavingsVal = everydaySavingsVal + promoGiftValueCalculated;
        totalSavingsEl.textContent = window.ayaCurrency.format(totalSavingsVal);
      }
    } else {
      displayPrice = compPriceVal > 0 ? compPriceVal : variantPrice;
      if (promoActiveCard && promoInactiveCard) {
        promoActiveCard.style.display = "none";
        promoInactiveCard.style.display = "flex";
      }
      if (compPriceDisplay) {
        compPriceDisplay.style.display = "none";
      }
      const savingsBoxVal = document.getElementById("SavingsBoxAmount");
      if (savingsBoxVal) {
        savingsBoxVal.textContent = window.ayaCurrency.format(everydaySavingsVal);
      }
    }

    if (priceDisplay) {
      priceDisplay.textContent = window.ayaCurrency.format(displayPrice);
    }

    const dropHintPriceInput = document.getElementById("DropHintFormPrice");
    if (dropHintPriceInput) dropHintPriceInput.value = window.ayaCurrency.format(displayPrice);
    const wishBtn = document.getElementById("ProductPageWishlistBtn");
    if (wishBtn) wishBtn.setAttribute("data-product-price", window.ayaCurrency.format(displayPrice));

    window.lastCalculatedPrice = displayPrice;
    window.lastCalculatedComparePrice = isPromoChecked ? compPriceVal : displayPrice;

    const propAnniversary = document.getElementById("PropAnniversarySale");
    const propGift = document.getElementById("PropFreeGift");
    if (propAnniversary) propAnniversary.value = isPromoChecked ? "Yes" : "No";
    if (propGift) propGift.value = isGiftEligible ? "Yes" : "No";
  }

  // Expose global recalculate function for standard products
  window.recalculateStandardPrice = updateStandardPrice;

  // GEMSTONE is the Diamond Origin selector.
  document.querySelectorAll('.aya-reference-gemstone .diamond-origin-selector').forEach(function(radio) {
    radio.addEventListener("change", function() {
      document.querySelectorAll('.aya-reference-gemstone-card').forEach(function(card) {
        card.classList.toggle(
          'is-active',
          !!card.querySelector('.diamond-origin-selector:checked')
        );
      });

      const label = document.getElementById("LabelSelectedGemstone");
      if (label) label.textContent = radio.value;

      const prop = document.getElementById("PropDiamondOrigin");
      if (prop) prop.value = radio.value;

      calculatePrice();
    });
  });

  // Bind radio buttons for standard variants
  const standardRadios = document.querySelectorAll(".standard-variant-radio");
  standardRadios.forEach(radio => {
    radio.addEventListener("change", function() {
      const optionBlock = radio.closest(".standard-option-block");
      if (optionBlock) {
        const label = optionBlock.querySelector(".standard-option-val-label");
        if (label) label.textContent = radio.value;
      }
      updateStandardPrice();
    });
  });

  if (anniversaryCheckbox) {
    anniversaryCheckbox.addEventListener("change", updateStandardPrice);
  }

  // Promo modal triggers for standard product
  initPromoModalListeners(globalRates);

  // Initial calculation
  updateStandardPrice();

  // Handle standard add to bag
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function(e) {
      e.preventDefault();
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = "Processing...";

      const isPromoChecked = anniversaryCheckbox ? anniversaryCheckbox.checked : false;
      const propAnniversary = document.getElementById("PropAnniversarySale");
      if (propAnniversary) propAnniversary.value = isPromoChecked ? "Yes" : "No";

      const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      if (productForm.dispatchEvent(submitEvent)) {
        HTMLFormElement.prototype.submit.call(productForm);
      }

      setTimeout(() => {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = "Add to bag";
      }, 1000);
    });
  }
}

function initCustomPricing() {
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) return;

  // Retrieve pricing configurations injected by Liquid
  const pricingConfigEl = document.getElementById("shopify-pricing-config");
  const productMetafieldsEl = document.getElementById("shopify-product-metafields");

  if (!pricingConfigEl || !productMetafieldsEl) return;

  const globalRates = JSON.parse(pricingConfigEl.textContent);
  const productMeta = JSON.parse(productMetafieldsEl.textContent);

  const priceDisplay = document.querySelector(".dynamic-price-display");
  const compPriceDisplay = document.querySelector(".dynamic-comp-price-display");
  const everydaySavingsEl = document.getElementById("EverydaySavingsValue");
  const totalSavingsEl = document.getElementById("TotalSavingsValue");
  const checkoutBtn = document.querySelector(".add-to-bag-btn");
 
  /*
   * AYA SHOPIFY VARIANT SYNC
   *
   * The custom metal/carats UI controls pricing, while Shopify
   * still requires the real ProductVariant ID for cart/checkout.
   */
  const variantsEl =
    document.getElementById("shopify-product-variants-json");

  let shopifyVariants = [];

  if (variantsEl) {
    try {
      shopifyVariants =
        JSON.parse(
          variantsEl.textContent || "[]"
        );
    } catch (variantJsonError) {
      console.warn(
        "[AYA Variant] Could not parse Shopify variants JSON:",
        variantJsonError
      );
      shopifyVariants = [];
    }
  }

  function ayaNormalizeVariantText(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");
  }

  function ayaVariantText(variant) {
    const options =
      Array.isArray(variant?.options)
        ? variant.options
        : [];

    return [
      variant?.title || "",
      ...options
    ].join(" ");
  }

  function ayaHasKarat(variant, karat) {
    if (!karat) return true;

    const source =
      ayaNormalizeVariantText(
        ayaVariantText(variant)
      );

    const digits =
      String(karat).match(/10|14|18/)?.[0];

    if (!digits) return true;

    return (
      source.includes(String(digits) + " k") ||
      source.includes(String(digits) + "k") ||
      source.includes(String(digits) + " kt") ||
      source.includes(String(digits) + "kt") ||
      source.includes(String(digits) + " karat")
    );
  }

  function ayaHasColor(variant, color) {
    if (!color) return true;

    const source =
      ayaNormalizeVariantText(
        ayaVariantText(variant)
      );

    const wanted =
      ayaNormalizeVariantText(
        color
      );

    return wanted
      ? source.includes(wanted)
      : true;
  }

  function ayaHasSize(variant, size) {
    if (!size) return false;

    const wanted =
      ayaNormalizeVariantText(
        size
      );

    const options =
      Array.isArray(variant?.options)
        ? variant.options
        : [];

    return options.some(function (option) {
      const normalized =
        ayaNormalizeVariantText(option);

      return (
        normalized === wanted ||
        normalized.includes(wanted) ||
        wanted.includes(normalized)
      );
    });
  }

  function ayaSelectedNativeOptionValues() {
    const values = [];

    document
      .querySelectorAll(
        'input[name^="options["]:checked, select[name^="options["]'
      )
      .forEach(function (element) {
        if (element?.value) {
          values.push(
            String(element.value)
          );
        }
      });

    return values;
  }

  function ayaSyncShopifyVariant() {

    const hiddenVariant =
      document.getElementById(
        "ProductSelectedVariantId"
      );

    if (!shopifyVariants.length) {
      return hiddenVariant?.value || "";
    }

    const combo =
      document.querySelector(
        'input[name="metal_combo"]:checked'
      );

    const karat =
      combo?.getAttribute("data-karat") ||
      document.querySelector(
        'input[name="karat"]:checked'
      )?.value ||
      document.getElementById(
        "HiddenSelectedKarat"
      )?.value ||
      "";

    const color =
      combo?.getAttribute("data-color") ||
      document.querySelector(
        'input[name="color"]:checked'
      )?.value ||
      document.getElementById(
        "HiddenSelectedColor"
      )?.value ||
      "";

    const size =
      document.querySelector(
        'select[name="size"]'
      )?.value ||
      "";

    let candidates =
      shopifyVariants.slice();

    /*
     * When the AYA custom metal selector is present, it is the
     * source of truth for karat/color. Do not let the hidden/native
     * Shopify picker override that selection.
     */
    if (!combo) {

      const nativeValues =
        ayaSelectedNativeOptionValues();

      nativeValues.forEach(function (selectedValue) {

        const exactMatches =
          candidates.filter(function (variant) {
            return (
              Array.isArray(
                variant?.options
              ) &&
              variant.options.some(function (option) {
                return (
                  ayaNormalizeVariantText(option) ===
                  ayaNormalizeVariantText(selectedValue)
                );
              })
            );
          });

        if (exactMatches.length) {
          candidates = exactMatches;
        }
      });

    }

    if (karat) {

      const karatMatches =
        candidates.filter(function (variant) {
          return ayaHasKarat(
            variant,
            karat
          );
        });

      if (karatMatches.length) {
        candidates = karatMatches;
      }
    }

    if (color) {

      const colorMatches =
        candidates.filter(function (variant) {
          return ayaHasColor(
            variant,
            color
          );
        });

      if (colorMatches.length) {
        candidates = colorMatches;
      }
    }

    if (size) {

      const sizeMatches =
        candidates.filter(function (variant) {
          return ayaHasSize(
            variant,
            size
          );
        });

      if (sizeMatches.length) {
        candidates = sizeMatches;
      }
    }

    if (!candidates.length) {
      candidates =
        shopifyVariants.slice();
    }

    const currentId =
      hiddenVariant?.value
        ? String(hiddenVariant.value)
        : "";

    let selected =
      candidates.find(function (variant) {
        return (
          String(variant.id) ===
          currentId
        );
      });

    if (!selected) {

      selected =
        candidates.find(function (variant) {
          return variant.available !== false;
        }) ||
        candidates[0];

    }

    if (!selected) {
      return currentId;
    }

    if (hiddenVariant) {
      hiddenVariant.value =
        String(selected.id);
    }

    document
      .querySelectorAll(
        'form[action="/cart/add"] input[name="id"]'
      )
      .forEach(function (input) {
        input.value =
          String(selected.id);
      });

    window.ayaSelectedVariant =
      selected;

    window.dispatchEvent(
      new CustomEvent(
        "aya:variant_changed",
        {
          detail: {
            variant:
              selected
          }
        }
      )
    );

    return String(selected.id);
  }

  window.ayaSyncShopifyVariant =
    ayaSyncShopifyVariant;


  const hasCustomPricing = productMeta.has_custom_pricing === true || productMeta.has_custom_pricing === "true";

  if (!hasCustomPricing) {
    initStandardProductHandler(productForm, globalRates, productMeta, priceDisplay, compPriceDisplay, everydaySavingsEl, totalSavingsEl, checkoutBtn);
    return;
  }

function calculatePrice() {

  /*
   * Resolve the current Shopify variant before pricing.
   */
  ayaSyncShopifyVariant();


  // ============================================================
  // 1. GET SELECTED METAL / KARAT / COLOR / CARAT
  // ============================================================

  const selectedComboEl =
    document.querySelector('input[name="metal_combo"]:checked');

  const selectedColorEl =
    document.querySelector('input[name="color"]:checked') ||
    document.getElementById("HiddenSelectedColor");

  const selectedKaratEl =
    document.querySelector('input[name="karat"]:checked') ||
    document.querySelector('select[name="karat"]') ||
    document.getElementById("HiddenSelectedKarat");

  const selectedCaratEl =
    document.querySelector('input[name="carat"]:checked') ||
    document.querySelector('select[name="carat"]');

  const selectedDiamondOriginEl =
    document.querySelector('.aya-reference-gemstone .diamond-origin-selector:checked');

  const rawDiamondOrigins = Array.isArray(productMeta.diamond_origins)
    ? productMeta.diamond_origins.map(function(value) {
        return String(value).trim();
      }).filter(Boolean)
    : [];

  const defaultDiamondOrigin =
    rawDiamondOrigins.includes("Lab Grown")
      ? "Lab Grown"
      : (rawDiamondOrigins[0] || "Lab Grown");

  let diamondOrigin = (
    selectedDiamondOriginEl?.value ||
    defaultDiamondOrigin
  ).trim();

  // Never use an origin that is not enabled in the product metafield list.
  if (rawDiamondOrigins.length && !rawDiamondOrigins.includes(diamondOrigin)) {
    diamondOrigin = defaultDiamondOrigin;
  }

  let metalType = "gold";
  let selectedKarat = "18K";
  let colorVal = "yellow";
  let selectedLabel = "18K Gold";


  // ============================================================
  // 2. READ METAL SELECTION
  // ============================================================

  if (selectedComboEl) {

    metalType = (
      selectedComboEl.getAttribute("data-metal-type") || "gold"
    ).toLowerCase();

    selectedKarat =
      selectedComboEl.getAttribute("data-karat") || "18K";

    colorVal = (
      selectedComboEl.getAttribute("data-color") || "Yellow"
    ).toLowerCase();

    selectedLabel =
      selectedComboEl.getAttribute("data-label") ||
      selectedComboEl.value;

  } else {

    // ----------------------------------------------------------
    // Metal Type
    // ----------------------------------------------------------

    if (
      selectedColorEl &&
      selectedColorEl.getAttribute("data-metal-type")
    ) {

      metalType = selectedColorEl
        .getAttribute("data-metal-type")
        .toLowerCase();

    } else if (productMeta && productMeta.metal_type) {

      metalType =
        productMeta.metal_type.toLowerCase();
    }


    // ----------------------------------------------------------
    // Karat
    // ----------------------------------------------------------

    if (selectedKaratEl) {

      selectedKarat =
        selectedKaratEl.value || "18K";
    }


    // ----------------------------------------------------------
    // Color
    // ----------------------------------------------------------

    if (selectedColorEl) {

      colorVal = (
        selectedColorEl.value || "Yellow"
      ).toLowerCase();
    }


    selectedLabel =
      `${selectedKarat} ${colorVal}`;
  }


  // ============================================================
  // 3. UPDATE SELECTED METAL LABELS
  // ============================================================

  const labelMetal =
    document.getElementById("LabelSelectedMetal");

  if (labelMetal && selectedLabel) {
    labelMetal.textContent = selectedLabel;
  }


  const infoMetal =
    document.getElementById("ProductInfoMetal");

  if (infoMetal && selectedLabel) {
    infoMetal.textContent = selectedLabel;
  }


  const propColor =
    document.getElementById("PropMetalColor");

  if (propColor && colorVal) {

    propColor.value =
      colorVal.charAt(0).toUpperCase() +
      colorVal.slice(1);
  }


  const propPurity =
    document.getElementById("PropMetalPurity");

  if (propPurity && selectedKarat) {
    propPurity.value = selectedKarat;
  }


  // ============================================================
  // 4. DIAMOND / CARAT
  // ============================================================

  const upgradeEnabled =
    productMeta.diamond_upgrade_enabled === true ||
    productMeta.diamond_upgrade_enabled === "true" ||
    productMeta.diamond_upgrade_enabled === "TRUE";

  const baseCarat =
    parseFloat(
      productMeta.base_carat ||
      productMeta.diamond_carat ||
      0
    ) || 0;

  /*
   * Diamond Upgrade ON:
   *
   * Base Carat is priced separately with:
   * Base Carat × Diamond Upgrade Rate
   *
   * Selected upgrade carat remains the customer
   * selected carat and uses the selected Diamond
   * Origin rate.
   *
   * Side diamonds use the selected Diamond Origin rate.
   *
   * Diamond Upgrade OFF:
   * Base Carat uses the selected Diamond Origin rate.
   */

  let selectedCarat = 0;

  if (upgradeEnabled) {

    if (selectedCaratEl) {

      const customerCarat =
        parseFloat(
          selectedCaratEl.value
        );

      if (
        !isNaN(customerCarat) &&
        customerCarat > 0
      ) {

        selectedCarat =
          customerCarat;

      }

    }

  } else {

    selectedCarat =
      baseCarat;

  }

  const labelCarat =
    document.getElementById("LabelSelectedCarat");

  if (labelCarat && selectedCaratEl) {

    labelCarat.textContent =
      selectedCaratEl.getAttribute("data-val-label") ||
      `${selectedCarat} Ct`;
  }


  const propCarat =
    document.getElementById("PropCenterCarat");

  if (propCarat) {
    propCarat.value = selectedCarat;
  }


  // ============================================================
  // 5. SIDE DIAMOND WEIGHT
  // ============================================================

  const sideDiamondWeight =
    parseFloat(
      productMeta["custom.side_diamonds_total_weight"] ||
      productMeta.side_diamonds_total_weight ||
      0
    ) || 0;


  /*
   * PRICEABLE DIAMOND CARATS
   *
   * Upgrade = TRUE:
   *   - Base Carat is included and has NO price.
   *   - Selected Carat is priced using the
   *     Natural/Lab Grown Upgrade Rate.
   *   - Moissanite has NO upgrade-price charge.
   *   - Side Diamonds are priced using the
   *     selected Diamond Origin rate.
   *
   * Upgrade = FALSE:
   *   - Base Carat is priced using the
   *     selected Diamond Origin rate.
   *   - Side Diamonds use the same origin rate.
   */
  const upgradePricedCarat =
    upgradeEnabled
      ? selectedCarat
      : 0;

  const originPricedSideCarat =
    sideDiamondWeight;

  const totalDiamondCarat =
    upgradeEnabled
      ? selectedCarat +
        sideDiamondWeight
      : baseCarat +
        sideDiamondWeight;


  // ============================================================
  // 6. DIAMOND RATES
  // ============================================================

  let diamondRate = 0;

  if (diamondOrigin === "Natural") {

    diamondRate =
      parseFloat(
        globalRates.natural_diamond_rate_per_carat
      );

  } else if (diamondOrigin === "Moissanite") {

    diamondRate =
      parseFloat(
        globalRates.moissanite_rate_per_carat
      );

  } else {

    diamondRate =
      parseFloat(
        globalRates.lab_grown_diamond_rate_per_carat
      );

  }

  if (isNaN(diamondRate)) {
    diamondRate = 0;
  }


  /*
   * Diamond Upgrade Upgrade Rate:
   *
   * Natural    → Natural Diamond Upgrade Rate
   * Lab Grown  → Lab Grown Diamond Upgrade Rate
   * Moissanite → NO upgrade-price change
   */
  let diamondUpgradeRate = 0;

  if (
    upgradeEnabled &&
    diamondOrigin === "Natural"
  ) {

    diamondUpgradeRate =
      parseFloat(
        globalRates.natural_diamond_upgrade_rate_per_carat
      ) || 0;

  } else if (
    upgradeEnabled &&
    diamondOrigin === "Lab Grown"
  ) {

    diamondUpgradeRate =
      parseFloat(
        globalRates.lab_grown_diamond_upgrade_rate_per_carat
      ) || 0;

  } else {

    diamondUpgradeRate = 0;

  }


  // ============================================================
  // 7. DIAMOND COST
  // ============================================================

  /*
   * MAIN DIAMOND RATE
   *
   * Upgrade = TRUE:
   *
   * Natural    -> Natural Diamond Upgrade Rate
   * Lab Grown  -> Lab Grown Diamond Upgrade Rate
   * Moissanite -> Normal Moissanite Rate
   *
   * Upgrade = FALSE:
   *
   * Base Carat -> Normal Diamond Origin Rate
   */
  const mainDiamondRate =
    upgradeEnabled
      ? (
          diamondOrigin === "Natural" ||
          diamondOrigin === "Lab Grown"
        )
        ? diamondUpgradeRate
        : diamondRate
      : diamondRate;

  /*
   * SIDE DIAMONDS ALWAYS USE NORMAL ORIGIN RATE:
   *
   * Natural    -> Natural Diamond Rate
   * Lab Grown  -> Lab Grown Diamond Rate
   * Moissanite -> Moissanite Rate
   */
  const sideDiamondRate =
    diamondRate;

  const sideDiamondCost =
    originPricedSideCarat *
    sideDiamondRate;

  /*
   * Base Carat is intentionally NOT priced when
   * Diamond Upgrade Enabled is True.
   */
  const baseDiamondCost =
    upgradeEnabled
      ? 0
      : baseCarat * diamondRate;

  /*
   * Main selected diamond cost.
   */
  const upgradeDiamondCost =
    upgradePricedCarat *
    mainDiamondRate;

  /*
   * Final diamond cost.
   */
  const diamondCost =
    upgradeDiamondCost +
    baseDiamondCost +
    sideDiamondCost;


  // ============================================================
  // 8. DIRECT METAL WEIGHT FROM KARAT METAFIELDS
  // ============================================================
  // The 10K / 14K / 18K metafields are already the finished metal
  // weights. No purity multiplication is applied.

  let weight = parseFloat(productMeta.net_metal_weight) || 0;
  let metalRate = 0;
  const normalizedKarat = String(selectedKarat).toUpperCase().replace(/\s/g, "");

  if (normalizedKarat.includes("10K") || normalizedKarat === "10") {
    weight = parseFloat(productMeta.metal_weight_10k) || 0;
    metalRate = parseFloat(globalRates.aya_10k_rate) || 0;
  } else if (normalizedKarat.includes("14K") || normalizedKarat === "14") {
    weight = parseFloat(productMeta.metal_weight_14k) || 0;
    metalRate = parseFloat(globalRates.aya_14k_rate) || 0;
  } else if (normalizedKarat.includes("18K") || normalizedKarat === "18") {
    weight = parseFloat(productMeta.metal_weight_18k) || 0;
    metalRate = parseFloat(globalRates.aya_18k_rate) || 0;
  }

  if (weight <= 0) weight = parseFloat(productMeta.net_metal_weight) || 0;

  // 9. SHOW / HIDE KARAT SELECTOR
  // ============================================================

  const karatContainer =
    document.getElementById("KaratSelectorContainer");

  if (karatContainer) {

    karatContainer.style.display =
      metalType === "gold" ? "grid" : "none";
  }


  // ============================================================
  // 10. DIRECT GOLD RATE BY SELECTED KARAT
  // ============================================================
  // 10K / 14K / 18K rates come directly from AYA Pricing Settings.

  let purityFactor = 1;
  if (!metalRate || metalRate <= 0) {
    metalRate = parseFloat(globalRates.aya_14k_rate) || 0;
    if (isNaN(metalRate)) metalRate = 0;
  }
  let goldRate = metalRate;

  // 12. MAKING CHARGE
  // ============================================================

  let makingCharge =
    parseFloat(
      globalRates.making_charge_per_gram
    );


  if (isNaN(makingCharge)) {
    makingCharge = 20;
  }


  // ============================================================
  // 13. INITIAL VARIABLES
  // ============================================================

  let actualGoldWeight = 0;
  let goldPrice = 0;
  let makingCost = 0;
  let metalCost = 0;
  let costPrice = 0;
  let finalPrice = 0;


  // ============================================================
  // 14. GOLD CALCULATION
  // ============================================================

  if (metalType === "gold") {

    // Direct finished metal weight from the selected 10K/14K/18K metafield.
    actualGoldWeight = weight;
    goldPrice = actualGoldWeight * goldRate;
    makingCost = actualGoldWeight * makingCharge;
    metalCost = goldPrice + makingCost;
    costPrice = metalCost + diamondCost;

    const rawMarkupMultiplier = parseFloat(globalRates.markup_multiplier);
    const markupMultiplier = (!isNaN(rawMarkupMultiplier) && rawMarkupMultiplier >= 0)
      ? (rawMarkupMultiplier === 0 ? 1 : rawMarkupMultiplier)
      : 1;

    finalPrice = Math.round((costPrice * markupMultiplier) + 40);
    window.lastCalculatedMarkupMultiplier = markupMultiplier;
  }  else if (metalType === "platinum") {

    let platinumRate =
      parseFloat(
        globalRates.platinum_rate
      );


    if (isNaN(platinumRate)) {
      platinumRate = 200;
    }


    // Platinum Metal Cost

    metalCost =
      weight * platinumRate;


    // Making Cost

    makingCost =
      weight * makingCharge;


    // Platinum + Diamond

    costPrice =
      metalCost +
      makingCost +
      diamondCost;


    // ----------------------------------------------------------
    // Markup
    // ----------------------------------------------------------

    const rawMarkupMultiplier =
      parseFloat(globalRates.markup_multiplier);

    let markupMultiplier;

    if (
      !isNaN(rawMarkupMultiplier) &&
      rawMarkupMultiplier >= 0
    ) {

      markupMultiplier =
        rawMarkupMultiplier === 0
          ? 1
          : rawMarkupMultiplier;

    } else {

      markupMultiplier = 1;
    }


    finalPrice =
      Math.round(
        costPrice * markupMultiplier
      );


    window.lastCalculatedMarkupMultiplier =
      markupMultiplier;
  }


  // ============================================================
  // 16. SILVER
  // ============================================================

  else if (metalType === "silver") {

    let silverRate =
      parseFloat(
        globalRates.silver_rate
      );


    if (isNaN(silverRate)) {
      silverRate = 10;
    }


    // Silver Metal Cost

    metalCost =
      weight * silverRate;


    // Making Cost

    makingCost =
      weight * makingCharge;


    // Silver + Diamond

    costPrice =
      metalCost +
      makingCost +
      diamondCost;


    // ----------------------------------------------------------
    // Markup
    // ----------------------------------------------------------

    const rawMarkupMultiplier =
      parseFloat(globalRates.markup_multiplier);

    let markupMultiplier;

    if (
      !isNaN(rawMarkupMultiplier) &&
      rawMarkupMultiplier >= 0
    ) {

      markupMultiplier =
        rawMarkupMultiplier === 0
          ? 1
          : rawMarkupMultiplier;

    } else {

      markupMultiplier = 1;
    }


    finalPrice =
      Math.round(
        costPrice * markupMultiplier
      );


    window.lastCalculatedMarkupMultiplier =
      markupMultiplier;
  }


  // ============================================================
  // 17. FALLBACK
  // ============================================================

  else {

    const fallbackRate =
      goldRate;


    actualGoldWeight = weight;


    goldPrice =
      actualGoldWeight *
      fallbackRate;


    makingCost =
      actualGoldWeight *
      makingCharge;


    metalCost =
      goldPrice +
      makingCost;


    costPrice =
      metalCost +
      diamondCost;


    // ----------------------------------------------------------
    // Markup
    // ----------------------------------------------------------

    const rawMarkupMultiplier =
      parseFloat(globalRates.markup_multiplier);

    let markupMultiplier;

    if (
      !isNaN(rawMarkupMultiplier) &&
      rawMarkupMultiplier >= 0
    ) {

      markupMultiplier =
        rawMarkupMultiplier === 0
          ? 1
          : rawMarkupMultiplier;

    } else {

      markupMultiplier = 1;
    }


    finalPrice =
      Math.round(
        costPrice * markupMultiplier
      );


    window.lastCalculatedMarkupMultiplier =
      markupMultiplier;
  }


  // ============================================================
  // 18. DEBUG
  // ============================================================

  console.log("[aya Pricing]", {

    // Metal
    metalType: metalType,
    netMetalWeight: weight,
    selectedKarat: selectedKarat,
    purityFactor: purityFactor,
    actualGoldWeight: actualGoldWeight,

    // Gold
    goldRate: goldRate,
    goldPrice: goldPrice,

    // Making
    makingChargePerGram: makingCharge,
    makingCost: makingCost,

    // Diamond
    mainDiamondCarat: selectedCarat,
    sideDiamondWeight: sideDiamondWeight,
    totalDiamondCarat: totalDiamondCarat,
    diamondRate: diamondRate,
    diamondCost: diamondCost,

    // Pricing
    metalCost: metalCost,
    costPrice: costPrice,

    markupMultiplier:
      window.lastCalculatedMarkupMultiplier,

    finalPrice: finalPrice
  });


  // ============================================================
  // 19. PROMO / COMPARE PRICE
  // ============================================================

  const isPromoShown =
    globalRates.promo_show !== false &&
    globalRates.promo_show !== "false";


  const anniversaryCheckbox =
    document.getElementById(
      "AnniversaryCheckbox"
    );


  const isPromoChecked =
    isPromoShown &&
    (
      anniversaryCheckbox
        ? anniversaryCheckbox.checked
        : true
    );


  // ============================================================
  // 20. COMPARE PRICE SETTINGS
  // ============================================================

  let compInflationPct =
    parseFloat(
      globalRates.comp_price_inflation_percentage
    );


  if (
    isNaN(compInflationPct) ||
    compInflationPct < 0
  ) {

    compInflationPct = 15;
  }


  const promoCompareMultiplier =
    1 + (compInflationPct / 100);


  // ============================================================
  // 21. FREE GIFT SETTINGS
  // ============================================================

  const promoGiftMinSpend =
    parseFloat(
      globalRates.promo_gift_min_spend
    ) || 1000;


  const promoGiftValue =
    parseFloat(
      globalRates.promo_gift_value
    ) || 245;


  // ============================================================
  // 22. COMPARE PRICE
  // ============================================================

  const compPriceVal =
    Math.round(
      finalPrice *
      promoCompareMultiplier
    );


  // ============================================================
  // 23. SAVINGS
  // ============================================================

  const everydaySavingsVal =
    Math.max(
      0,
      compPriceVal - finalPrice
    );


  // ============================================================
  // 24. GIFT ELIGIBILITY
  // ============================================================

  const isGiftEligible =
    finalPrice >= promoGiftMinSpend;


  let displayPrice =
    finalPrice;


  let totalSavingsVal = 0;


  // ============================================================
  // 25. PROMO CARDS
  // ============================================================

  const promoActiveCard =
    document.getElementById(
      "PromoActiveCard"
    );


  const promoInactiveCard =
    document.getElementById(
      "PromoInactiveCard"
    );


  // ============================================================
  // 26. PROMO ACTIVE
  // ============================================================

  if (isPromoChecked) {

    displayPrice =
      finalPrice;


    if (
      promoActiveCard &&
      promoInactiveCard
    ) {

      promoActiveCard.style.display =
        "block";

      promoInactiveCard.style.display =
        "none";
    }


    // ----------------------------------------------------------
    // Compare Price
    // ----------------------------------------------------------

    if (compPriceDisplay) {

      compPriceDisplay.textContent =
        window.ayaCurrency.format(
          compPriceVal
        );

      compPriceDisplay.style.display =
        "inline";
    }


    // ----------------------------------------------------------
    // Everyday Savings
    // ----------------------------------------------------------

    if (everydaySavingsEl) {

      everydaySavingsEl.textContent =
        "-" +
        window.ayaCurrency.format(
          everydaySavingsVal
        );
    }


    // ----------------------------------------------------------
    // Total Savings
    // ----------------------------------------------------------

    if (totalSavingsEl) {

      const promoGiftValueCalculated =
        isGiftEligible
          ? promoGiftValue
          : 0;


      totalSavingsVal =
        everydaySavingsVal +
        promoGiftValueCalculated;


      totalSavingsEl.textContent =
        window.ayaCurrency.format(
          totalSavingsVal
        );
    }

  }


  // ============================================================
  // 27. PROMO INACTIVE
  // ============================================================

  else {

    displayPrice =
      compPriceVal;


    if (
      promoActiveCard &&
      promoInactiveCard
    ) {

      promoActiveCard.style.display =
        "none";

      promoInactiveCard.style.display =
        "block";
    }


    if (compPriceDisplay) {

      compPriceDisplay.style.display =
        "none";
    }


    if (everydaySavingsEl) {

      everydaySavingsEl.textContent =
        "";
    }


    if (totalSavingsEl) {

      totalSavingsEl.textContent =
        "";
    }
  }


  // ============================================================
  // 28. UPDATE MAIN PRICE DISPLAY
  // ============================================================

  if (priceDisplay) {

    priceDisplay.textContent =
      window.ayaCurrency.format(
        displayPrice
      );
  }


  // ============================================================
  // 29. SAVE CALCULATED VALUES GLOBALLY
  // ============================================================

  window.lastCalculatedPrice =
    displayPrice;


  window.lastCalculatedComparePrice =
    isPromoChecked
      ? compPriceVal
      : displayPrice;


  window.lastCalculatedCostPrice =
    costPrice;


  window.lastCalculatedDiamondCost =
    diamondCost;

  window.dispatchEvent(new CustomEvent("aya:custom_price_updated", {
    detail: {
      price: Number(displayPrice) || 0,
      comparePrice: Number(window.lastCalculatedComparePrice) || 0
    }
  }));


  window.lastCalculatedTotalDiamondCarat =
    totalDiamondCarat;


  // IMPORTANT:
  // Do NOT use `|| 1` here.

  window.lastCalculatedMarkupMultiplier =
    window.lastCalculatedMarkupMultiplier;


  // ============================================================
  // 30. RETURN PRICE
  // ============================================================

  return finalPrice;
}


  // Expose global recalculate function
    /*
   * GEMSTONE = DIAMOND ORIGIN
   * Every card shows the full calculated product total for its origin.
   */
  function refreshGemstoneCalculatedPrices() {
    const cards = Array.from(document.querySelectorAll('.aya-reference-gemstone .aya-reference-gemstone-card'));
    const radios = cards.map(function(card) { return card.querySelector('.diamond-origin-selector'); }).filter(Boolean);
    if (!radios.length) return;

    const activeRadio = radios.find(function(radio) { return radio.checked; }) || radios[0];
    const prices = new Map();

    radios.forEach(function(radio) {
      radio.checked = true;
      const calculated = calculatePrice();
      prices.set(radio.value, Number(calculated) || Number(window.lastCalculatedPrice) || 0);
    });

    radios.forEach(function(radio) {
      radio.checked = radio === activeRadio;
    });

    calculatePrice();

    cards.forEach(function(card) {
      const radio = card.querySelector('.diamond-origin-selector');
      const priceEl = card.querySelector('[data-gemstone-price]');
      if (!radio || !priceEl) return;

      const amount = prices.get(radio.value) || 0;
      priceEl.textContent = window.ayaCurrency && typeof window.ayaCurrency.format === 'function'
        ? window.ayaCurrency.format(amount)
        : '$' + Math.round(amount).toLocaleString('en-US');

      card.classList.toggle('is-active', radio.checked);
      card.setAttribute('aria-pressed', radio.checked ? 'true' : 'false');
    });

    const selectedLabel = document.getElementById('LabelSelectedGemstone');
    if (selectedLabel) selectedLabel.textContent = activeRadio.value || '';
  }

  function selectGemstoneCard(card) {
    if (!card) return;
    const radio = card.querySelector('.diamond-origin-selector');
    if (!radio) return;

    radio.checked = true;
    document.querySelectorAll('.aya-reference-gemstone-card').forEach(function(item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-pressed', 'false');
    });
    card.classList.add('is-active');
    card.setAttribute('aria-pressed', 'true');

    const label = document.getElementById('LabelSelectedGemstone');
    if (label) label.textContent = radio.value || '';

    const prop = document.getElementById('PropDiamondOrigin');
    if (prop) prop.value = radio.value || '';

    calculatePrice();
    refreshGemstoneCalculatedPrices();
  }
window.recalculateCustomPrice = calculatePrice;
  window.triggerPricingCalculate = calculatePrice;

  // Bind custom input changes to live price updates
  const customSelectors = document.querySelectorAll(
    'input[name="metal_combo"], input[name="color"], input[name="karat"], input[name="carat"], input[name="ring_size"], .pricing-selector, .color-selector, .metal-combo-input, .carat-selector'
  );
  
  function triggerDelayedCalculate() {
    calculatePrice();
    setTimeout(calculatePrice, 30);
    setTimeout(calculatePrice, 80);
    setTimeout(function() {
      calculatePrice();
      refreshGemstoneCalculatedPrices();
    }, 160);
  }

  customSelectors.forEach(selector => {
    selector.addEventListener('change', triggerDelayedCalculate);
    selector.addEventListener('click', triggerDelayedCalculate);
    selector.addEventListener('input', triggerDelayedCalculate);
  });

  // Global delegation on document for dynamic or deferred radio/swatch clicks
  document.addEventListener('change', function (e) {
    if (e.target && (
      e.target.matches('input[name="metal_combo"]') ||
      e.target.matches('input[name="color"]') ||
      e.target.matches('input[name="karat"]') ||
      e.target.matches('input[name="carat"]') ||
      e.target.matches('.metal-combo-input') ||
      e.target.matches('.pricing-selector')
    )) {
      triggerDelayedCalculate();
    }
  });


 
  /*
   * Keep Shopify's real ProductVariant synchronized with
   * native variant controls, AYA metal buttons, and ring size.
   */
  document.addEventListener("change", function(e) {

    if (
      e.target &&
      (
        e.target.matches('variant-radios input') ||
        e.target.matches('variant-selects select') ||
        e.target.matches('input[name^="options["]') ||
        e.target.matches('select[name^="options["]') ||
        e.target.matches('select[name="size"]')
      )
    ) {

      setTimeout(function() {
        ayaSyncShopifyVariant();
        calculatePrice();
      }, 0);

    }

  });

  document.addEventListener("variant:change", function(e) {

    const variant =
      e?.detail?.variant ||
      e?.detail ||
      null;

    const id =
      variant?.id ||
      e?.detail?.id ||
      "";

    if (id) {

      const hiddenVariant =
        document.getElementById(
          "ProductSelectedVariantId"
        );

      if (hiddenVariant) {
        hiddenVariant.value =
          String(id);
      }

    }

    ayaSyncShopifyVariant();
    calculatePrice();

  });

  const anniversaryCheckbox = document.getElementById("AnniversaryCheckbox");
  if (anniversaryCheckbox) {
    anniversaryCheckbox.addEventListener('change', triggerDelayedCalculate);
  }

  // GEMSTONE = Diamond Origin. The card itself selects the real pricing origin.
  document.querySelectorAll('.aya-reference-gemstone .diamond-origin-selector').forEach(function(radio) {
    radio.addEventListener("change", function() {
      selectGemstoneCard(radio.closest('.aya-reference-gemstone-card'));
    });
  });

  document.querySelectorAll('.aya-reference-gemstone-card').forEach(function(card) {
    card.addEventListener('click', function(event) {
      if (event.target && event.target.matches('.diamond-origin-selector')) return;
      event.preventDefault();
      selectGemstoneCard(card);
    });
  });
  // Initial calculation
  calculatePrice();
  refreshGemstoneCalculatedPrices();

  // Handle bag submission
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = "Processing...";

      const price = calculatePrice();

      /*
       * Final variant sync immediately before cart submission.
       */
      ayaSyncShopifyVariant();

      const selectedComboEl = document.querySelector('input[name="metal_combo"]:checked');
      const karat = selectedComboEl?.getAttribute("data-karat") || document.querySelector('input[name="karat"]:checked')?.value || document.getElementById("HiddenSelectedKarat")?.value || "14K";
      const colorVal = selectedComboEl?.getAttribute("data-color") || document.querySelector('input[name="color"]:checked')?.value || document.getElementById("HiddenSelectedColor")?.value || "Yellow";
      const size = document.querySelector('select[name="size"]')?.value || "6";
      const upgradeEnabled = productMeta.diamond_upgrade_enabled === true || productMeta.diamond_upgrade_enabled === 'true' || productMeta.diamond_upgrade_enabled === 'TRUE';
      const carat = (upgradeEnabled && document.querySelector('input[name="carat"]:checked')?.value) || productMeta.base_carat || "1";

      const isPromoChecked = document.getElementById("AnniversaryCheckbox")?.checked || false;
      const promoGiftMinSpend = parseFloat(globalRates.promo_gift_min_spend) || 1000;
      const isGiftEligible = isPromoChecked && price >= promoGiftMinSpend;

      // Dynamically create or update hidden custom properties input fields in the product form
      function setHiddenProperty(name, value) {
        let input = productForm.querySelector(`input[name="properties[${name}]"]`);
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = `properties[${name}]`;
          productForm.appendChild(input);
        }
        input.value = value;
      }

      setHiddenProperty("Metal Color", colorVal);
      setHiddenProperty("Metal Purity", karat);
      setHiddenProperty("Center Carat", carat);
      setHiddenProperty("Ring Size", size);
      setHiddenProperty("Anniversary Sale", isPromoChecked ? "Yes" : "No");
      setHiddenProperty("Free Gift", isGiftEligible ? "Yes" : "No");
      setHiddenProperty("_custom_price", window.lastCalculatedPrice || price);
      setHiddenProperty("_custom_comp_price", window.lastCalculatedComparePrice || price);

      // Dispatch standard submit event so AJAX drawers or themes can intercept
      const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      if (productForm.dispatchEvent(submitEvent)) {
        HTMLFormElement.prototype.submit.call(productForm);
      }

      // Restore button text after a brief delay
      setTimeout(() => {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = "Add to bag";
      }, 1000);
    });

    initPromoModalListeners(globalRates);
  }
}

// Resilient initialization check in case DOMContentLoaded has already fired
function bootayaScripts() {
  if (window.ayaCurrency && typeof window.ayaCurrency.init === "function") {
    window.ayaCurrency.init();
  }
  initCustomPricing();
  initProductCards();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootayaScripts);
} else {
  bootayaScripts();
}




/**
 * AYA MATCHING/BUNDLE CUSTOM PRICE DISPLAY
 *
 * Lightweight version:
 * - No MutationObserver.
 * - No repeated DOM-wide observer scans.
 * - Runs at page load and during a short finite retry window.
 * - Uses the existing product-page HTML to calculate linked custom prices.
 */

(function initAyaMatchingCustomPriceDisplay() {
  'use strict';

  var cache = {};

  function num(v) {
    var n = parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  function json(doc, id) {
    var el = doc.querySelector(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function format(value) {
    if (window.ayaCurrency && typeof window.ayaCurrency.format === 'function') {
      return window.ayaCurrency.format(value);
    }
    return '$' + Math.round(value).toLocaleString('en-US');
  }

  function customPriceFromDoc(doc) {
    var meta = json(doc, '#shopify-product-metafields');
    var rates = json(doc, '#shopify-pricing-config');
    if (!meta || !rates) return null;

    var w14 = num(meta.metal_weight_14k);
    var raw = num(meta.net_metal_weight);
    var w = w14 > 0 ? w14 : raw;

    if (
      !(meta.has_custom_pricing === true ||
        meta.has_custom_pricing === 'true' ||
        num(meta.metal_weight_10k) > 0 ||
        num(meta.metal_weight_14k) > 0 ||
        num(meta.metal_weight_18k) > 0 ||
        raw > 0)
    ) return null;

    if (w <= 0) return null;

    var rate = num(rates.aya_14k_rate);

     var making = num(rates.making_charge_per_gram);
     var origin = String(meta.diamond_origin || 'Lab Grown').trim();
     var diamondRate = origin === 'Natural'
       ? num(rates.natural_diamond_rate_per_carat)
       : origin === 'Moissanite'
         ? num(rates.moissanite_rate_per_carat)
         : num(rates.lab_grown_diamond_rate_per_carat);
    var markup = num(rates.markup_multiplier);
    if (markup <= 0) markup = 1;

    var upgrade =
      meta.diamond_upgrade_enabled === true ||
      meta.diamond_upgrade_enabled === 'true' ||
      meta.diamond_upgrade_enabled === 'TRUE';

    var baseCarat =
      num(
        meta.base_carat ||
        meta.diamond_carat
      );

    var center =
      upgrade
        ? 0
        : baseCarat;

    var side =
      num(
        meta.side_diamonds_total_weight
      );

    var diamondUpgradeRate = 0;

    if (
      upgrade &&
      origin === 'Natural'
    ) {

      diamondUpgradeRate =
        num(
          rates.natural_diamond_upgrade_rate_per_carat
        );

    } else if (
      upgrade &&
      origin === 'Lab Grown'
    ) {

      diamondUpgradeRate =
        num(
          rates.lab_grown_diamond_upgrade_rate_per_carat
        );

    } else {

      diamondUpgradeRate = 0;

    }

    /*
     * Secondary/card price calculation:
     *
     * Upgrade ON:
     *   Base Carat = NOT priced.
     *   Selected upgrade carat is not available in this
     *   lightweight context, so only side diamonds use
     *   the selected origin rate.
     *
     * Upgrade OFF:
     *   Base Carat + side diamonds use origin rate.
     */
    var upgradeDiamondCost = 0;

    var baseDiamondCost =
      upgrade
        ? 0
        : baseCarat * diamondRate;

    var mainDiamondRate =
      upgrade
        ? (
            origin === 'Natural' ||
            origin === 'Lab Grown'
          )
          ? diamondUpgradeRate
          : diamondRate
        : diamondRate;

    /*
     * Side diamonds always use normal origin rate.
     */
    var sideDiamondRate =
      diamondRate;

    var mainDiamondCost =
      upgrade
        ? (center * mainDiamondRate)
        : 0;

    var originDiamondCost =
      upgrade
        ? (side * sideDiamondRate)
        : ((center + side) * diamondRate);

    var cost =
      (w * rate) +
      (w * making) +
      mainDiamondCost +
      upgradeDiamondCost +
      baseDiamondCost +
      originDiamondCost;

    var price = Math.round((cost * markup) + 40);

    var inflation = num(rates.comp_price_inflation_percentage);
    if (!isFinite(inflation) || inflation < 0) inflation = 15;

    var compareMultiplier = 1 + (inflation / 100);

    return {
      price: price,
      compare: Math.round(price * compareMultiplier)
    };
  }

  function getPrice(url) {
    var key = url.split('?')[0].split('#')[0];

    if (cache[key]) return cache[key];

    cache[key] = fetch(key, { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.text();
      })
      .then(function(html) {
        return customPriceFromDoc(
          new DOMParser().parseFromString(html, 'text/html')
        );
      })
      .catch(function() { return null; });

    return cache[key];
  }

  function isMatchingContainer(el) {
    if (!el) return false;

    var text = (el.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();

    return /buy together and save|recommended matching band/i.test(text);
  }

  function findCard(link) {
    var card = link.parentElement;

    for (var level = 0; level < 10 && card; level++) {
      if (
        card.querySelector('.product-card-sm__info__price') ||
        card.querySelector('.product-card-sm-custom-price')
      ) {
        return card;
      }

      card = card.parentElement;
    }

    return null;
  }

  function setCardPrice(card, result) {
    if (!card || !result || result.price <= 0) return;

    var priceEl =
      card.querySelector('.product-card-sm-custom-price .price-item--sale') ||
      card.querySelector('.product-card-sm__info__price .price-item--sale') ||
      card.querySelector('.product-card-sm__info__price .price-item') ||
      card.querySelector('.product-card-sm__info__price .price');

    /*
     * If the current product is still rendered with the normal
     * $0.00 markup, use the first currency-bearing element inside
     * the small product price wrapper.
     */
    if (!priceEl) {
      var wrapper =
        card.querySelector('.product-card-sm__info__price');

      if (wrapper) {
        var nodes = wrapper.querySelectorAll('span, div, p, s');

        for (var i = 0; i < nodes.length; i++) {
          var txt = (nodes[i].textContent || '').trim();

          if (/^\$?0(?:\.00)?$/.test(txt) || /^\$?[0-9,]+(?:\.\d{2})?$/.test(txt)) {
            priceEl = nodes[i];
            break;
          }
        }
      }
    }

    if (!priceEl) return;

    priceEl.textContent = format(result.price);
    priceEl.setAttribute('data-aya-custom-price', String(result.price));

    var compareEl =
      card.querySelector('.product-card-sm__info__price s') ||
      card.querySelector('.product-card-sm__info__price [class*="regular"]');

    if (compareEl && result.compare > result.price) {
      compareEl.textContent = format(result.compare);
    }
  }

  function updateMatchingPrices() {
    var currentPath = window.location.pathname;
    var links = document.querySelectorAll('a[href*="/products/"]');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var href = link.getAttribute('href') || '';
      var cleanHref = href.split('?')[0].split('#')[0];

      if (!cleanHref) continue;

      var container = link.parentElement;
      var matching = false;

      for (var level = 0; level < 10 && container; level++) {
        if (isMatchingContainer(container)) {
          matching = true;
          break;
        }
        container = container.parentElement;
      }

      if (!matching) continue;

      var card = findCard(link);
      if (!card) continue;

      /*
       * CURRENT PRODUCT:
       * Always use the live custom variation price.
       * This specifically fixes the $0.00 shown for "This Test".
       */
      if (
        cleanHref === currentPath &&
        typeof window.ayaLastCustomPrice === 'number' &&
        isFinite(window.ayaLastCustomPrice) &&
        window.ayaLastCustomPrice > 0
      ) {
        setCardPrice(card, {
          price: window.ayaLastCustomPrice,
          compare: num(window.ayaLastCustomComparePrice)
        });
        continue;
      }

      /*
       * MATCHING PRODUCT:
       * Calculate its custom price from its own product data.
       */
      (function(linkURL, linkCard) {
        getPrice(linkURL).then(function(result) {
          setCardPrice(linkCard, result);
        });
      })(cleanHref, card);
    }
  }

  function boot() {
    updateMatchingPrices();

    var retries = 0;
    var timer = setInterval(function() {
      updateMatchingPrices();
      retries++;

      if (retries >= 10) {
        clearInterval(timer);
      }
    }, 800);

    window.addEventListener(
      'aya:custom_price_updated',
      function() {
        updateMatchingPrices();
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/**
 * Product Card Swatch Interactivity and Info Modal Toggle
 */
function initProductCards() {
  console.log("[aya] Initializing product cards swatches and modal handler via event delegation");

  // 1. Swatch click handler using Event Delegation
  document.addEventListener("click", function(e) {
    const dot = e.target.closest(".card-swatch-dot-lux");
    if (!dot) return;

    e.preventDefault();
    e.stopPropagation();

    console.log("[aya] Swatch clicked:", dot.getAttribute("data-label"), "Price:", dot.getAttribute("data-price"));

    const card = dot.closest(".product-card-lux");
    if (!card) {
      console.warn("[aya] Card container (.product-card-lux) not found for clicked swatch.");
      return;
    }

    // Update active swatch dot styling
    const siblingDots = card.querySelectorAll(".card-swatch-dot-lux");
    siblingDots.forEach(d => d.classList.remove("active"));
    dot.classList.add("active");

    // Read values from data attributes
    const rawPrice = dot.getAttribute("data-price-raw");
    const rawCompPrice = dot.getAttribute("data-comp-price-raw");
    const newPrice = rawPrice && window.ayaCurrency ? window.ayaCurrency.formatCents(rawPrice) : dot.getAttribute("data-price");
    const newCompPrice = rawCompPrice && window.ayaCurrency ? window.ayaCurrency.formatCents(rawCompPrice) : dot.getAttribute("data-comp-price");
    const newImage = dot.getAttribute("data-image");
    const newLabel = dot.getAttribute("data-label");

    // Update card elements
    const mainImg = card.querySelector(".card-main-img");
    const labelEl = card.querySelector(".card-metal-label-lux");
    const priceEl = card.querySelector(".card-price-lux");
    const compPriceEl = card.querySelector(".card-comp-price-lux");
    const wishBtn = card.querySelector(".card-wishlist-btn-lux");

    if (mainImg) {
      if (newImage) {
        mainImg.src = newImage;
        console.log("[aya] Updated main image src to:", newImage);
      }
    }

    if (labelEl && newLabel) {
      labelEl.textContent = newLabel;
    }
    if (priceEl && newPrice) {
      priceEl.textContent = newPrice;
      if (rawPrice) priceEl.setAttribute("data-price-raw", rawPrice);
    }
    if (wishBtn && newPrice) {
      wishBtn.setAttribute("data-price", newPrice);
      if (rawPrice) wishBtn.setAttribute("data-price-raw", rawPrice);
    }
    if (compPriceEl) {
      if (newCompPrice) {
        compPriceEl.textContent = newCompPrice;
        if (rawCompPrice) compPriceEl.setAttribute("data-comp-price-raw", rawCompPrice);
        compPriceEl.style.display = "inline";
      } else {
        compPriceEl.style.display = "none";
      }
    }
  });

  // 2. Modal open/close handler
  const modalOverlay = document.getElementById("CompValueInfoModal");
  const modalCloseBtn = document.getElementById("CompValueInfoModalClose");

  window.openCompValueModal = function() {
    if (modalOverlay) {
      modalOverlay.style.display = "flex";
      modalOverlay.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden"; // Prevent background scroll
    }
  };

  function closeCompValueModal() {
    if (modalOverlay) {
      modalOverlay.style.display = "none";
      modalOverlay.setAttribute("aria-hidden", "true");
      document.body.style.overflow = ""; // Restore scroll
    }
  }

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener("click", function(e) {
      e.preventDefault();
      closeCompValueModal();
    });
  }

  if (modalOverlay) {
    modalOverlay.addEventListener("click", function(e) {
      // Close only if clicked on the overlay background, not the content box
      if (e.target === modalOverlay) {
        closeCompValueModal();
      }
    });
  }

  // Allow Esc key to close the modal
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && modalOverlay && modalOverlay.style.display === "flex") {
      closeCompValueModal();
    }
  });
}
